module.exports = __webpack_public_path__ + "img/Abibois_good_format.483f4d7d.webp";